var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("SideBarLeft"),
          _vm._v(" "),
          _c("div", { staticClass: "col order-1 order-lg-2" }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _c("router-view", {
                      key: _vm.$route.params.lecture,
                      on: { loginModal: _vm.loginModal },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SideBarRight"),
        ],
        1
      ),
      _vm._v(" "),
      _c("PasswordLogin", { ref: "passwordLogin" }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "congratsModal",
          staticClass: "modal fade",
          attrs: { tabindex: "-1", role: "dialog" },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("Congratulations!"))),
                  ]),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("All lectures marked as completed"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.hideCongratsModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("Ok")))]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }